// Journal article pages: builds the "In this guide" contents list from the article's headings and highlights the
// section being read. Without JavaScript the list simply stays hidden.
(function () {
  var body = document.querySelector("[data-cka-body]"), toc = document.querySelector("[data-cka-toc]");
  if (!body || !toc) return;
  var heads = Array.prototype.slice.call(body.querySelectorAll("h2")), used = {};
  if (heads.length < 3) { var g = toc.closest(".cka-grid"); if (g) g.classList.add("no-toc"); return; }
  var list = toc.querySelector("[data-cka-list]");
  heads.forEach(function (h, i) {
    var id = h.id || h.textContent.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "").slice(0, 48) || "s" + (i + 1);
    while (used[id]) id += "-" + i;
    used[id] = 1; h.id = id;
    var a = document.createElement("a"); a.href = "#" + id; a.textContent = h.textContent.trim(); a.setAttribute("data-id", id); list.appendChild(a);
  });
  toc.hidden = false;
  if (window.matchMedia("(max-width:960px)").matches) toc.removeAttribute("open"); else toc.setAttribute("open", "");
  if (!("IntersectionObserver" in window)) return;
  var links = list.querySelectorAll("a");
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { links.forEach(function (l) { l.classList.toggle("on", l.getAttribute("data-id") === e.target.id); }); } });
  }, { rootMargin: "-20% 0px -70% 0px" });
  heads.forEach(function (h) { io.observe(h); });
})();
